import { render } from "./OpacityPage.vue?vue&type=template&id=62202fc1&ts=true"
import script from "./OpacityPage.vue?vue&type=script&lang=ts"
export * from "./OpacityPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__